import React, { useContext, useEffect } from "react";
import UserContext from "../components/UserContext";
import { getApps, getHomePageContent, getSiteSettings } from "../lib/api";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import Home from "./home";

export default function HomePage({ content, apps, siteSettings }) {
  const { scrollRef } = useContext(UserContext);
  const liveContent = useContentfulLiveUpdates(content);
  useEffect(() => {
    window.scrollTo(0, scrollRef.current.scrollPos);
    const handleScrollPos = () => {
      scrollRef.current.scrollPos = window.scrollY;
    };
    window.addEventListener("scroll", handleScrollPos);
    return () => {
      window.removeEventListener("scroll", handleScrollPos);
    };
  });

  return (
    <>
      <Home content={liveContent} apps={apps} siteSettings={siteSettings} />
    </>
  );
}

export async function getStaticProps({ params, draftMode = false }) {
  const [data, apps, siteSettings] = await Promise.all([
    getHomePageContent(params?.id, draftMode),
    getApps(draftMode),
    getSiteSettings(draftMode),
  ]);
  return {
    props: {
      content: data.content ?? null,
      apps,
      siteSettings,
      draftMode,
    },
    revalidate: 10,
  };
}
